<template lang="pug">
  v-col.lesson-create
    h1.mb-2 {{ isUpdate ? 'Изменить' : 'Добавить' }} урок
    v-slide-y-reverse-transition
      v-row(v-if="lessonLoading")
        v-col(cols=12 md=6)
          v-skeleton-loader(
            type="card-heading, list-item@3"
          )
        v-col(cols=12 md=6)
          v-skeleton-loader(
            type="card-heading, list-item@3"
          )
        v-col(cols=12)
          v-skeleton-loader(
            type="table-thead, list-item@2"
          )
      v-row(v-else)
        v-col
          v-slide-y-reverse-transition
            v-form(ref="form")
              // Основаная форма с данными
              lesson-create-main-form.mb-5(
                v-model="lesson"
                :lesson-instance="lesson"
              )
</template>

<script>
import LessonService from '@/services/API/LessonService';

import LessonCreateMainForm from './LessonCreateMainForm.vue';

export default {
  name: 'LessonCreate',
  components: {
    LessonCreateMainForm,
  },
  data: () => ({
    lesson: null,
    lessonLoading: false,
  }),
  computed: {
    isUpdate() {
      return !!this.lesson;
    },
  },
  mounted() {
    if (this.$route.params.lessonId) {
      this.getLesson(this.$route.params.lessonId);
    }
  },
  methods: {
    getLesson(id) {
      this.lessonLoading = true;
      const params = {
        expand: 'content_links,content_files,content_lecture,content_telegram,telegram',
      };
      this.$rHandler(
        LessonService.getLesson(id, params),
        (r) => {
          this.lesson = r.data.data;
          if (this.lesson.date_start) this.lesson.date_start = r.data.data.date_start.slice(0, -3);
          if (this.lesson.date_end) this.lesson.date_end = r.data.data.date_end.slice(0, -3);
          this.lessonLoading = false;
        },
        () => {},
      );
    },
  },
};
</script>
